import clsx from "clsx";
import type { ComponentPropsWithoutRef } from "react";
import styles from "./index.module.css";

export type ButtonVariant =
  | "primary"
  | "secondary"
  | "white"
  | "danger"
  | "dark-gradient"
  | "light-gradient"
  | "orange"
  | "white-outline"
  | "text";
export type ButtonSize = "default" | "large";

export const Button = ({
  children,
  className,
  disabled,
  isLoading = false,
  variant = "primary",
  size = "default",
  width = "100%",
  ...props
}: ComponentPropsWithoutRef<"button"> & {
  isLoading?: boolean;
  variant?: ButtonVariant;
  size?: ButtonSize;
  width?: string;
}) => (
  <button
    className={clsx(styles.button, className)}
    data-size={size}
    data-variant={variant}
    disabled={disabled || isLoading}
    style={{ width }}
    type="button"
    {...props}
  >
    {isLoading && <span className={styles.loadingIndicator} />}
    {children}
  </button>
);
